import css from "styled-jsx/css";

export const componentStyles = css.global`
  .footer-container {
    &.slim-footer {
      .footer-content-container {
        padding-top: 48px;
        .footer-content {
          .categories-container {
            .category-container {
              &:not(:first-child) {
                margin-top: 8px;
              }
              &:last-child {
                flex-grow: 3;
              }
            }
          }
        }
      }
    }
  }
`;
